<template>
    <div class="agent-page">
        <!-- 页面头部 -->
        <div class="page-header">
            <div style="display: flex; flex-direction: column; text-align: start;">
                <h2 class="page-title">{{ projectTitle }}</h2>
                <h2 class="page-title" style="margin-top: 10px;">资格审查</h2>
            </div>
        </div>

        <!-- 搜索区域 -->
        <div class="search-section">
            <el-form :inline="true" :model="searchForm">
                <el-form-item label="标段名称">
                    <el-input v-model="searchForm.bidSectionName" placeholder="请输入标段名称" clearable
                        style="width: 300px;" />
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
                    <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
                </el-form-item>
            </el-form>
             <div style="display: flex; align-items: center;">
                <el-button type="primary" icon="el-icon-arrow-left" @click="handleBack">返回项目流程界面</el-button>

            </div>
        </div>

        <!-- 数据表格 -->
        <div class="table-section">
            <el-table :data="tableData" v-loading="loading" border style="width: 100%" class="data-table">
                <el-table-column prop="no" label="NO." width="60" align="center" />
                <el-table-column prop="bidSectionCode" label="标段编码" show-overflow-tooltip />
                <el-table-column prop="bidSectionName" label="标段名称" show-overflow-tooltip />
                <el-table-column prop="status" label="状态" align="center" width="100">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.status === 0 ? 'info' : 'success'">
                            {{ scope.row.status === 0 ? '暂存' : '提交' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="详细信息" align="center" width="150">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="handleSetQualification(scope.row)"
                            class="action-btn">

                            {{ scope.row.status === 0 ? '审核' : '查看' }}
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 分页 -->
        <div class="pagination-section">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="pagination.currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pagination.pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="pagination.total" class="pagination" />
        </div>
        <!-- 设置资格审查内容弹窗 -->
        <el-dialog title="资格审查" :visible.sync="qualificationDialogVisible" width="90%" top="5vh"
            :before-close="handleCloseDialog" :append-to-body="true" class="qualification-dialog">
            <div class="qualification-content">
                <!-- 投标人列表 -->
                <div v-if="qualificationList.length === 0" class="empty-data">
                    <el-empty description="暂无数据"></el-empty>
                </div>

                <el-collapse v-else v-model="activeNames" accordion class="bidder-collapse">
                    <el-collapse-item v-for="(bidder, bidderIndex) in qualificationList" :key="bidderIndex"
                        :name="bidderIndex">
                        <template slot="title">
                            <div class="collapse-title">
                                <span class="bidder-name">
                                    <i class="el-icon-user-solid"></i>
                                    投标人：{{ bidder.bidderName }}
                                </span>
                                <span class="review-status">
                                    <el-tag :type="getBidderStatusType(bidder)" size="small">
                                        {{ getBidderStatusText(bidder) }}
                                    </el-tag>
                                </span>
                                <el-button type="primary" size="small" icon="el-icon-document"
                                    @click.stop="handleViewFiles(bidder)" style="margin-left: 10px;">
                                    查看文件
                                </el-button>
                            </div>
                        </template>

                        <!-- 审查项目表格 -->
                        <el-table :data="bidder.contents" border stripe class="review-table"
                            :header-cell-style="{ background: '#f5f7fa', color: '#606266', fontWeight: 'bold' }">
                            <el-table-column type="index" label="序号" width="60" align="center">
                            </el-table-column>

                            <el-table-column prop="reviewItemName" label="审查项名称" show-overflow-tooltip>
                            </el-table-column>

                            <el-table-column prop="reviewCondition" label="审查条件" show-overflow-tooltip>
                            </el-table-column>

                            <el-table-column label="审查结果" align="center">
                                <template slot-scope="scope">
                                    <div class="review-result-buttons">
                                        <el-button :disabled="status != 0"
                                            :type="scope.row.isPass === 1 ? 'success' : 'default'"
                                            :plain="scope.row.isPass !== 1" size="small" class="result-btn pass-btn"
                                            @click="handleSetPass(scope.row, 1)">
                                            <i class="el-icon-circle-check"></i>
                                            通过
                                        </el-button>
                                        <el-button :disabled="status != 0"
                                            :type="scope.row.isPass === 0 ? 'danger' : 'default'"
                                            :plain="scope.row.isPass !== 0" size="small" class="result-btn fail-btn"
                                            @click="handleSetPass(scope.row, 0)">
                                            <i class="el-icon-circle-close"></i>
                                            不通过
                                        </el-button>
                                    </div>
                                </template>
                            </el-table-column>

                            <el-table-column label="不通过原因">
                                <template slot-scope="scope">
                                    <el-input v-if="scope.row.isPass === 0" v-model="scope.row.notPassReason"
                                        type="textarea" :rows="2" placeholder="请输入不通过原因" maxlength="200" show-word-limit
                                        clearable :disabled="status != 0">
                                    </el-input>
                                    <span v-else class="not-required-text">—</span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-collapse-item>
                </el-collapse>
            </div>

            <div slot="footer" class="dialog-footer">
                <el-button @click="handleCloseDialog">取消</el-button>
                <el-button type="primary" @click="handleSave" :loading="saving" v-if="status == 0">
                    <i class="el-icon-check"></i> 保存审查结果
                </el-button>
            </div>
        </el-dialog>

        <!-- 文件列表弹窗 -->
        <el-dialog title="投标文件列表" :visible.sync="fileListDialogVisible" width="600px" :append-to-body="true">
            <el-table :data="currentFileList" border stripe>
                <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                <el-table-column prop="fileName" label="文件名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="fileSize" label="文件大小" width="120" align="center">
                    <template slot-scope="scope">
                        {{ formatFileSize(scope.row.fileSize) }}
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="100" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" icon="el-icon-download" @click="handleDownloadFile(scope.row)">
                            下载
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button @click="fileListDialogVisible = false">关闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { loadProjectDetail } from '@/utils/projectInfo.js'

import { getFileDownloadList, getFileList } from '@/api/base/api'
import { qualificationReviewList, qualificationReviewAdd, qualificationReviewResultDetail, qualificationReviewAddResult } from '@/api/qualificationReview/api.js'
export default {
    data() {
        return {
            projectCode: this.$route.query.projectCode,
            projectTitle: '',
            loading: false,
            qualificationDialogVisible: false,
            status: 0,
            saving: false,
            searchForm: {
                bidSectionName: ''
            },
            tableData: [],
            pagination: {
                currentPage: 1,
                pageSize: 10,
                total: 0
            },
            qualificationList: [],
            currentBidSectionCode: '', // 当前选中的标段编码
            activeNames: 0, // 折叠面板激活的项
            fileListDialogVisible: false, // 文件列表弹窗
            currentFileList: [] // 当前查看的文件列表
        }
    },
    computed: {
        // 获取投标人状态类型
        getBidderStatusType() {
            return (bidder) => {
                if (!bidder.contents || bidder.contents.length === 0) return 'info'

                const allReviewed = bidder.contents.every(item => item.isPass !== null)
                if (!allReviewed) return 'warning'

                const allPassed = bidder.contents.every(item => item.isPass === 1)
                return allPassed ? 'success' : 'danger'
            }
        },
        // 获取投标人状态文本
        getBidderStatusText() {
            return (bidder) => {
                if (!bidder.contents || bidder.contents.length === 0) return '无审查项'

                const allReviewed = bidder.contents.every(item => item.isPass !== null)
                if (!allReviewed) return '待审查'

                const allPassed = bidder.contents.every(item => item.isPass === 1)
                return allPassed ? '全部通过' : '存在不通过项'
            }
        }
    },

    mounted() {
        this.getProjectInfo()
        this.loadData()
    },
    methods: {
        //  获取标题
        async getProjectInfo() {
            this.projectTitle = await loadProjectDetail(this.projectCode);
        },

        // 搜索
        handleSearch() {
            this.pagination.currentPage = 1
            this.loadData()
        },

        // 重置
        handleReset() {
            this.searchForm.bidSectionName = ''
            this.pagination.currentPage = 1
            this.loadData()
        },

        //列表
        loadData() {
            this.loading = true
            qualificationReviewList({
                projectCode: this.projectCode,
                bidSectionName: this.searchForm.bidSectionName,
                pageNum: this.pagination.currentPage,
                pageSize: this.pagination.pageSize,
                stage: 0
            }).then(res => {
                if (res.code === 200) {
                    const data = res.data
                    this.tableData = data.records.map((item, index) => ({
                        no: (this.pagination.currentPage - 1) * this.pagination.pageSize + index + 1,
                        bidSectionCode: item.bidSectionCode,
                        bidSectionName: item.bidSectionName,
                        status: item.status
                    }))
                    this.pagination.total = data.total
                }
            }).catch(err => {
                this.$message.error('获取标段列表失败');
                console.error(err);
            }).finally(() => {
                this.loading = false;
            });
        },

        handleBack() {
            this.$router.go(-1)
        },
        handleSetQualification(row) {
            this.status = row.status
            this.currentBidSectionCode = row.bidSectionCode

            this.qualificationReviewResultDetail(row.bidSectionCode)
        },
        // 获取资格审查内容
        qualificationReviewResultDetail(bidSectionCode) {
            this.loading = true
            qualificationReviewResultDetail({
                bidSectionCode: bidSectionCode,
            }).then(res => {
                if (res.code === 200) {
                    // 设置数据并默认展开第一个投标人
                    this.qualificationList = res.data || []
                    this.activeNames = 0
                    this.qualificationDialogVisible = true


                } else {
                    this.$message.error(res.msg);
                }
            }).catch(err => {
                this.$message.error('获取资格审查内容失败');
                console.error(err);
            }).finally(() => {
                this.loading = false;
            });
        },

        // 设置审查结果
        handleSetPass(row, value) {
            row.isPass = value
            // 如果选择通过，清空不通过原因
            if (value === 1) {
                row.notPassReason = null
            }
        },

        // 查看投标人文件
        handleViewFiles(bidder) {
            if (bidder.fileList && bidder.fileList.length > 0) {
                this.currentFileList = bidder.fileList
                this.fileListDialogVisible = true
            } else {
                this.$message.warning('该投标人暂无文件')
            }
        },

        // 下载文件
        handleDownloadFile(file) {
            this.getFileDownloadList(file.fileId)
        },
        /**
      * 获取文件下载列表
      */
        async getFileDownloadList(fileGuid) {
            if (!fileGuid) {
                this.$message.warning('文件标识不存在，无法下载')
                return
            }
            try {
                const res = await getFileDownloadList(fileGuid)
                if (res.code === 200 && res.data) {
                    this.handleDownloadFiles(res.data)
                } else {
                    this.$message.error(res.msg || '获取文件列表失败')
                    this.downloadDialogVisible = false
                }
            } catch (error) {
                console.error('获取文件下载列表失败:', error)
                this.$message.error('获取文件下载列表失败，请重试')
            } finally {
                this.downloadLoading = false
            }
        },
        /**
    * 下载文件
    */
        handleDownloadFiles(fileInfo) {
            if (!fileInfo.fileUrl) {
                this.$message.error('文件下载地址不存在')
                return
            }
            try {
                // 使用 window.open 在新窗口中打开下载链接
                window.open(fileInfo.fileUrl, '_blank')
                this.$message.success(`开始下载文件：${fileInfo.fileName}`)
            } catch (error) {
                console.error('下载文件失败:', error)
                this.$message.error('下载文件失败，请重试')
            }
        },


        // 格式化文件大小
        formatFileSize(size) {
            if (!size) return '0 B'
            const units = ['B', 'KB', 'MB', 'GB']
            let unitIndex = 0
            let fileSize = size
            while (fileSize >= 1024 && unitIndex < units.length - 1) {
                fileSize /= 1024
                unitIndex++
            }
            return `${fileSize.toFixed(2)} ${units[unitIndex]}`
        },

        handleSizeChange(val) {
            this.pagination.pageSize = val
            this.loadData()
        },

        handleCurrentChange(val) {
            this.pagination.currentPage = val
            this.loadData()
        },



        // 关闭弹窗
        handleCloseDialog() {
            this.qualificationDialogVisible = false
            this.qualificationList = []
            this.activeNames = 0
        },

        // 保存
        handleSave() {
            // 验证数据 - 检查每个投标人的每个审查项
            for (let i = 0; i < this.qualificationList.length; i++) {
                const bidder = this.qualificationList[i]

                for (let j = 0; j < bidder.contents.length; j++) {
                    const item = bidder.contents[j]

                    // 检查是否已选择审查结果
                    if (item.isPass === null || item.isPass === undefined) {
                        this.$message.warning(`投标人【${bidder.bidderName}】的第${j + 1}项审查条件未选择审查结果`)
                        return
                    }

                    // 如果不通过，必须填写原因
                    if (item.isPass === 0 && (!item.notPassReason || !item.notPassReason.trim())) {
                        this.$message.warning(`投标人【${bidder.bidderName}】的第${j + 1}项审查条件不通过，必须填写原因`)
                        return
                    }
                }
            }
            this.saving = true
            const params = {
                result: this.qualificationList.map(bidder => ({
                    bidSectionCode: bidder.bidSectionCode,
                    bidderId: bidder.bidderId,
                    bidderName: bidder.bidderName,
                    fileGuid: bidder.fileGuid || '',
                    contents: bidder.contents.map(item => ({
                        qualificationReviewCode: item.qualificationReviewCode,
                        reviewItemKey: item.reviewItemKey,
                        reviewItemName: item.reviewItemName,
                        reviewCondition: item.reviewCondition,
                        isPass: item.isPass,
                        notPassReason: item.notPassReason || null
                    }))
                }))
            }
            console.log(JSON.stringify(params));

            qualificationReviewAddResult(params).then(res => {
                if (res.code === 200) {
                    this.$message.success('保存审查结果成功')
                    this.qualificationDialogVisible = false
                    this.qualificationList = []
                    // 刷新列表
                    this.loadData()
                } else {
                    this.$message.error(res.msg || '保存失败')
                }
            }).catch(err => {
                this.$message.error('保存失败')
                console.error(err)
            }).finally(() => {
                this.saving = false
            })
        }
    }
}
</script>

<style lang="less" scoped>
// 引入极简灰度配色公共样式
@import '@/styles/minimal-gray-theme.less';

// ============================================
// 应用极简灰度主题
// ============================================
.agent-page {
    .apply-minimal-gray-theme();
}

// ============================================
// 页面特定样式
// ============================================

// 页面头部（带返回按钮）
.page-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 20px;
    gap: 20px;

    .page-title {
        font-size: 20px;
        font-weight: 600;
        color: @gray-700;
        margin: 0;
        line-height: 1.5;
        position: relative;
        padding-left: 10px;

        &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 3px;
            height: 16px;
            background: @gray-700;
            border-radius: 2px;
        }

        &:first-child::before {
            background: @primary-color;
        }
    }

    /deep/ .el-button {
        transition: all @transition-base ease;

        &:hover {
            transform: translateY(-1px);
        }

        &:active {
            transform: translateY(0);
        }
    }
}

// ============================================
// 弹窗样式
// ============================================
/deep/ .qualification-dialog {
    .minimal-dialog-styles();

    .el-dialog__body {
        max-height: 70vh;
        overflow-y: auto;
        background-color: @gray-50;

        // 滚动条样式
        &::-webkit-scrollbar {
            width: 6px;
        }

        &::-webkit-scrollbar-thumb {
            background: @gray-300;
            border-radius: 3px;

            &:hover {
                background: @gray-400;
            }
        }
    }
}

.qualification-content {
    .empty-data {
        padding: 40px 0;
        text-align: center;
    }

    .bidder-collapse {
        border: none;

        /deep/ .el-collapse-item {
            margin-bottom: 16px;
            border-radius: 4px;
            overflow: hidden;
            box-shadow: @shadow-sm;
            background-color: #fff;
            transition: box-shadow @transition-base ease;

            &:hover {
                box-shadow: @shadow-md;
            }

            &:last-child {
                margin-bottom: 0;
            }
        }

        /deep/ .el-collapse-item__header {
            height: auto;
            line-height: 1.5;
            padding: 16px 20px;
            background-color: #fff;
            border-bottom: 1px solid @gray-200;
            font-size: 15px;
            transition: background-color @transition-fast ease;

            &:hover {
                background-color: @gray-50;
            }

            &.is-active {
                border-bottom-color: @primary-color;
            }
        }

        /deep/ .el-collapse-item__wrap {
            border-bottom: none;
            background-color: @gray-50;
        }

        /deep/ .el-collapse-item__content {
            padding: 20px;
        }

        .collapse-title {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            padding-right: 20px;

            .bidder-name {
                font-size: 16px;
                font-weight: 600;
                color: @gray-700;
                display: flex;
                align-items: center;

                i {
                    margin-right: 8px;
                    font-size: 18px;
                    color: @primary-color;
                }
            }

            .review-status {
                margin-left: auto;
            }
        }
    }

    .review-table {
        border-radius: 4px;
        overflow: hidden;

        /deep/ .el-table__header {
            th {
                font-weight: 600;
            }
        }

        .review-result-buttons {
            display: flex;
            gap: 8px;
            justify-content: center;
            align-items: center;

            .result-btn {
                flex: 1;
                min-width: 80px;
                font-weight: 500;
                transition: all 0.3s ease;
                border-radius: 6px;

                i {
                    margin-right: 4px;
                    font-size: 14px;
                }

                &.pass-btn {
                    &.el-button--success {
                        background: linear-gradient(135deg, #67c23a 0%, #85ce61 100%);
                        border-color: #67c23a;
                        box-shadow: 0 2px 8px rgba(103, 194, 58, 0.3);

                        &:hover {
                            transform: translateY(-2px);
                            box-shadow: 0 4px 12px rgba(103, 194, 58, 0.4);
                        }
                    }

                    &.el-button--default {
                        &:hover {
                            color: #67c23a;
                            border-color: #67c23a;
                            background-color: #f0f9ff;
                        }
                    }
                }

                &.fail-btn {
                    &.el-button--danger {
                        background: linear-gradient(135deg, #f56c6c 0%, #f78989 100%);
                        border-color: #f56c6c;
                        box-shadow: 0 2px 8px rgba(245, 108, 108, 0.3);

                        &:hover {
                            transform: translateY(-2px);
                            box-shadow: 0 4px 12px rgba(245, 108, 108, 0.4);
                        }
                    }

                    &.el-button--default {
                        &:hover {
                            color: #f56c6c;
                            border-color: #f56c6c;
                            background-color: #fef0f0;
                        }
                    }
                }
            }
        }

        .not-required-text {
            color: @gray-500;
            font-size: 14px;
        }
    }
}

.dialog-footer {
    text-align: center;
    padding: 16px 0 10px;
    border-top: 1px solid @gray-200;
    margin-top: 16px;

    .el-button {
        padding: 10px 24px;
        font-size: 14px;
        transition: all @transition-base ease;

        &:hover {
            transform: translateY(-1px);
        }

        i {
            margin-right: 4px;
        }
    }
}
</style>
